import type { Language } from "@/context";

const translations = {
  en: {
    heroGreeting: "Hi there, I'm David",
    heroPassion: "passionate about web technologies",
    typewriter: ["Full stack Developer"],
    aboutMeLabel: "<about me>",
    aboutMeCloseLabel: "</about me>",
    aboutMeText:
      "I'm a proactive, organized and responsible person with good communication skills. I have more than 5 years of experience in software development. Focused on teamwork, leadership, and teaching my skills.",
    projectsLabel: "<my portfolio>",
    projectsCloseLabel: "</my portfolio>",
    skillsLabel: "<my skills>",
    skillsCloseLabel: "</my skills>",
    buildingTitle: "Website under renovation!",
    buildingText: "Sorry for the inconvenience, it will be available soon.",
    notFoundTitle: "Page not found",
    notFoundText: "The page you are looking for does not exist.",
    copyright: "Copyright:",
    navHome: "Home",
    navProjects: "Projects",
    navAboutMe: "About Me",
    navSkills: "Skills",
    heroSection: "Introduction",
    projectsSection: "Projects",
    aboutMeSection: "About Me",
    skillsSection: "Skills",
    sectionNav: "Section navigation",
    socialLinks: "Social links",
    workExperience: "Work experience",
    toggleLight: "Switch to light mode",
    toggleDark: "Switch to dark mode",
    profileAlt: "David Angarita profile photo",
    techUsed: "Technologies used",
    skipToContent: "Skip to content",
  },
  es: {
    heroGreeting: "Hola, soy David",
    heroPassion: "apasionado por las tecnologías web",
    typewriter: ["Desarrollador Full stack"],
    aboutMeLabel: "<sobre mí>",
    aboutMeCloseLabel: "</sobre mí>",
    aboutMeText:
      "Soy una persona proactiva, organizada y responsable con buenas habilidades de comunicación. Tengo más de 5 años de experiencia en desarrollo de software. Enfocado en trabajo en equipo, liderazgo y enseñanza.",
    projectsLabel: "<mi portafolio>",
    projectsCloseLabel: "</mi portafolio>",
    skillsLabel: "<mis habilidades>",
    skillsCloseLabel: "</mis habilidades>",
    buildingTitle: "¡Sitio web en renovación!",
    buildingText: "Disculpa las molestias, estará disponible pronto.",
    notFoundTitle: "Página no encontrada",
    notFoundText: "La página que buscas no existe.",
    copyright: "Derechos reservados:",
    navHome: "Inicio",
    navProjects: "Proyectos",
    navAboutMe: "Sobre mí",
    navSkills: "Habilidades",
    heroSection: "Introducción",
    projectsSection: "Proyectos",
    aboutMeSection: "Sobre mí",
    skillsSection: "Habilidades",
    sectionNav: "Navegación de secciones",
    socialLinks: "Redes sociales",
    workExperience: "Experiencia laboral",
    toggleLight: "Cambiar a modo claro",
    toggleDark: "Cambiar a modo oscuro",
    profileAlt: "Foto de perfil de David Angarita",
    techUsed: "Tecnologías utilizadas",
    skipToContent: "Saltar al contenido",
  },
} as const;

type StringKeys = {
  [K in keyof (typeof translations)["en"]]: (typeof translations)["en"][K] extends string ? K : never;
}[keyof (typeof translations)["en"]];

export type TranslationKey = StringKeys;

export function t(lang: Language, key: TranslationKey): string {
  return translations[lang][key] as string;
}

export function tArray(lang: Language, key: "typewriter"): readonly string[] {
  return translations[lang][key];
}
